<template>
	<div class="userpage" :class="mode">
		<div class="navbar" :class="(mode === 'dark') ? 'dark' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				Settings
			</div>
			<i v-on:click="$router.push('/Support')" class="material-icons">help</i>
		</div>
		<div class="wrapper">
			<div class="setting--wrapper">
				<div class="head">Appereances</div>
				<div class="content--wrapper" style="flex-flow: row !important">
					<div class="title--wrapper">
						<div class="title">Dark Theme</div>
						<div class="subtitle">for low-light environment</div>
					</div>
					<label class="toggle">
						<input 
						type="checkbox" 
						:checked="(mode === 'dark') ? 'checked' : false" 
						@change="toggle"
						/>
						<span class="toggler round"></span>
					</label>
				</div>
			</div>
			<div class="setting--wrapper">
				<div class="head">About</div>
				<div class="content--wrapper">
					<div v-on:click="$router.push('/Version')" class="title--wrapper">
						<div class="title">Version</div>
						<div class="subtitle">Beta 0.8.3</div>
					</div>
					<div v-on:click="$router.push('/ThirdPartySoftware')" class="title--wrapper">
						<div class="title">Third-party software</div>
						<div class="subtitle">Open-source software that helped us</div>
					</div>
					<div v-on:click="$router.push('/Terms')" class="title--wrapper">
						<div class="title">Terms and Conditions</div>
						<div class="subtitle">All the stuff you need to know</div>
					</div>
					<div v-on:click="$router.push('/Privacy')" class="title--wrapper">
						<div class="title">Privacy Policy</div>
						<div class="subtitle">Important for both of us</div>
					</div>
					<div v-on:click="$router.push('/Support')" class="title--wrapper">
						<div class="title">Support</div>
						<div class="subtitle">Get help from us and feedback</div>
					</div>
				</div>
			</div>
			<div class="setting--wrapper">
				<div class="head">Other</div>
				<div class="content--wrapper">
					<div v-on:click="logout" class="title--wrapper">
						<div class="title">Log out</div>
						<div class="subtitle">You are logged in as {{ $store.state.currentUser.displayName }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import firebase from 'firebase'
export default {
	data() {
		return {
			mode: null,
		}
	},
	methods: {
		toggle: function() {
			if (this.mode == 'light') {
				this.mode = 'dark'
			} else {
				this.mode = 'light'
			}
			localStorage.mode = this.mode
			this.$store.commit('setMode', localStorage.mode);
		},
		logout: function() {
			let _this = this
			firebase.auth().signOut().then(function() {
				_this.$store.commit('setCurrentUser',null)
				setTimeout(() => _this.isHidden = false, 1000);
				_this.$router.push('/landing')
			}).catch(function(error) {
				_this.console.log(error)
			});
		}
	},
	mounted() {
		this.mode = localStorage.mode
	},
};
</script>
<style lang="scss" scoped>
$base-color: #1b7b46;
$inner-color: #caefe2;
$accent-color: #2fca74;
.userpage {
	position: absolute;
	width: 100%;
	padding-bottom: 3.4rem;
	background: #fff;
	color: #000;
}
.dark {
	background: #000;
	color: #fff;
}
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	backdrop-filter: blur(1px);
	background-image: linear-gradient(rgb(0,0,0), transparent);
	.title {
		font-size: 14px;
	}
}
.wrapper {
	padding: 5rem 1.5rem 0;
	.setting--wrapper {
		padding: 0 0 1rem;
		.head {
			font-size: 12px;
			margin-bottom: .8rem;
			opacity: .9;
		}
		.content--wrapper {
			display: flex;
			flex-flow: column;
			justify-content: space-between;
			.title--wrapper {
				padding: 0 0 1.5rem;
				.title {
					font-size: 12px;
				}
				.subtitle {
					opacity: .5;
					font-size: 10px;
					letter-spacing: .020rem;
					text-transform: lowercase;
				}
				&:active {
					opacity: .5;
				}
			}
			.toggle {
				position: relative;
				display: inline-block;
				width: 4rem;
				height: 2rem;
			}
			.toggle input {
				opacity: 0;
				width: 0;
				height: 0;
			}
			.toggler {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: rgba(0,0,0, .2);
			}
			.toggler:before {
				position: absolute;
				content: "";
				width: 1.25rem;
				height: 1.25rem;
				background: #FFF;
			}
			input:checked + .toggler {
				padding: 0 .4rem;
				background-color: $base-color;
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}
			input:focus + toggler {
				box-shadow: 0 0 2px $base-color;
			}
			.toggler.round {
				display: flex;
				align-items: center;
				border-radius: 20px;
				justify-content: flex-start;
				padding: 0 .3rem;

			}
			.toggler.round:before {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				border-radius: 20px;
				box-shadow: 0 2px 2px 1px rgba(0,0,0, .05);
			}
		}
	}
}
</style>